import { ItemSearchJsEnv } from './item_search_js_env';
import { SpecSearchKey } from './item_search_spec';

export class ItemSearch {
  constructor(private model: ItemSearchJsEnv) {
    this.model = { ...model };
  }
  updateModel(newModel: ItemSearchJsEnv) {
    this.model = { ...newModel };
  }

  getModel(): ItemSearchJsEnv {
    return {
      ...this.model
    };
  }
  setIsEnable(isEnable: boolean): void {
     this.model.isEnable = isEnable;
  }

  setSpecSearchKey(specSearchKey: SpecSearchKey[]): void {
    this.model.specSearchKey = specSearchKey;
  }

}
